import React from "react";
import { useNavigate } from "react-router-dom";
import instituteImg from "./assets/institute.jpeg";

const Institute = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${instituteImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          background: "rgba(0,0,0,0.4)",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
        }}
      >
        <h1>Welcome to the Institute 🏫</h1>
        <p>Let’s begin your learning journey!</p>

        <button
          onClick={() => navigate("/welcome")}
          style={{
            marginTop: "20px",
            padding: "12px 30px",
            fontSize: "18px",
            borderRadius: "30px",
            border: "none",
            cursor: "pointer",
          }}
          
        >
          Get started 
        </button>
      </div>
    </div>
  );
};

export default Institute;
